import { createSvgComponent } from "../../icon/createSvgComponent";
import MyFill from "@core/icon/assets/my-fill.svg";
export default createSvgComponent(MyFill);